export const QUERY_KEYS = {
  TIP_OF_THE_DAY: "tip-of-the-day",
  DOCTORS: "doctors",
};
